const MS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;

/**
 * Formats a remaining duration as "h:mm:ss" (hours unpadded, e.g. "1:43:46").
 * Negative or missing durations clamp to "0:00:00".
 */
export function formatCountdown(remainingMs: number | null | undefined): string {
  const totalSeconds = Math.max(0, Math.floor((remainingMs ?? 0) / MS_PER_SECOND));

  const hours = Math.floor(totalSeconds / SECONDS_PER_HOUR);
  const minutes = Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
  const seconds = totalSeconds % SECONDS_PER_MINUTE;

  const paddedMinutes = String(minutes).padStart(2, '0');
  const paddedSeconds = String(seconds).padStart(2, '0');

  return `${hours}:${paddedMinutes}:${paddedSeconds}`;
}
